var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tutorial",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.983,
    height: 68.983,
    viewBox: "0 0 68.983 68.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17440",
    "data-name": "Path 17440",
    d: "M62.92,0H6.063A6.07,6.07,0,0,0,0,6.063V49.446a6.07,6.07,0,0,0,6.063,6.063H25.29l-.911,4.557a6.079,6.079,0,0,1-5.945,4.874h-5.5a2.021,2.021,0,0,0,0,4.042H56.048a2.021,2.021,0,0,0,0-4.042h-5.5A6.079,6.079,0,0,1,44.6,60.067l-.911-4.557H62.92a6.07,6.07,0,0,0,6.063-6.063V6.063A6.07,6.07,0,0,0,62.92,0ZM40.641,60.859a10.044,10.044,0,0,0,1.831,4.081H26.51a10.043,10.043,0,0,0,1.831-4.081l1.07-5.35h10.16Zm24.3-11.413a2.023,2.023,0,0,1-2.021,2.021H6.063a2.023,2.023,0,0,1-2.021-2.021V6.063A2.023,2.023,0,0,1,6.063,4.042H62.92a2.023,2.023,0,0,1,2.021,2.021Z",
    fill: "#b23130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17441",
    "data-name": "Path 17441",
    d: "M173.021,85.6h18.862a2.021,2.021,0,0,0,2.021-2.021V82.231a11.458,11.458,0,0,0-5.847-9.981,7.41,7.41,0,1,0-11.21,0A11.458,11.458,0,0,0,171,82.231v1.347A2.021,2.021,0,0,0,173.021,85.6Zm6.063-18.189a3.368,3.368,0,1,1,3.368,3.368A3.372,3.372,0,0,1,179.084,67.41Zm3.368,7.41a7.42,7.42,0,0,1,7.38,6.737h-14.76A7.42,7.42,0,0,1,182.452,74.82Z",
    transform: "translate(-147.961 -51.916)",
    fill: "#b23130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17442",
    "data-name": "Path 17442",
    d: "M111.524,284.695H74.473v-.674a2.021,2.021,0,0,0-4.042,0v.674h-7.41a2.021,2.021,0,1,0,0,4.042h7.41v.674a2.021,2.021,0,0,0,4.042,0v-.674h37.051a2.021,2.021,0,1,0,0-4.042Z",
    transform: "translate(-52.781 -244.006)",
    fill: "#b23130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.9a967c6c5eff60537088c61c6d932333.svg";
export { ForwardRef as ReactComponent };